import React from "react";
import Header from "./../../components/Header";
import "./Home.sass";
import Hero from "./Hero";
import Enlist from "./Enlist";
import Machine from "./Machine";
import Footer from "./Footer";

export default function Home() {
  const headerBg = "url(/images/home-header.png)";
  return (
    <div className="home">
      <Header bg={headerBg} />
      <Hero />
      <Enlist />
      <Machine />
      <Footer />
    </div>
  );
}
